import React, { Component } from "react";
import Swal from 'sweetalert2';
import { Col, Button, Form, FormGroup, Label, Input, Modal, ModalHeader, ModalBody, ModalFooter, Row } from 'reactstrap';
import { api_url } from "./globalFunction/global_string";
import { GoogleReCaptchaProvider, GoogleReCaptcha } from 'react-google-recaptcha-v3';

import "./Form.css";
export class FormForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email_F: '',
      loggedIn: false,
      isResetPasswordModalOpen: false, // 新增模式對話框的顯示狀態
      reCaptchaValue: '',
      refreshReCaptcha: false,
    };
  }
  handleReCaptcha = (value) => {
    this.setState({ reCaptchaValue: value });
  }
  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };
  componentDidMount() {
    this.handleRefreshReCaptcha();
  }
  handleRefreshReCaptcha = () => {
    this.setState(prevState => ({ refreshReCaptcha: !prevState.refreshReCaptcha }));
  };
  handleResetPassword = (e) => {
    e.preventDefault();
    let apiUrl = api_url + '/api/Auth/SendEmailAsync';
    const formData = new FormData();
    formData.append("E_mail", this.state.email_F);
    formData.append("reCaptchaValue", this.state.reCaptchaValue);
    fetch(apiUrl,
      {
        method: "POST",
        body: formData
      })
      .then(response => {
        try {
          return response.json();
        } catch (error) {
          console.error('Error parsing JSON:', error);
          throw error
        };
      })
      .then(data => {
        let arr_status = [String(data.statusCode), data.row, data.detail]
        switch (arr_status[0]) {
          case "200":
            Swal.fire({
              icon: 'success',
              title: '【寄送成功】',
              text: '恭喜'
            });
            this.setState({
              email_F: '',
              isRecaptchaVerified: false,
            });
            break;
          case "401":
            Swal.fire({
              icon: 'error',
              title: '【查無此信箱】',
              text: 'sorry'
            });
            break;
          case "500":
            window.location.href = '404'
            break;
          default:
        }
      }).finally(() => {
        this.handleRefreshReCaptcha();
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }

  render() {
    return (
      <Form onSubmit={this.handleResetPassword}>
        <div className="d-flex align-items-center justify-content-center">
          <p style={{ textAlign: 'center' }}>請輸入您註冊時的電子郵件，我們將向您發送重設密碼的說明<br />
            為確保網路安全疑慮，忘記密碼時需重新設置新密碼，我們不會透過電子郵件發送您的舊密碼</p>
        </div>
        <FormGroup row>
          <Label for="email_F" sm={2} className="text-right">信箱</Label>
          <Col sm={10}>
            <Input type="email" name="email_F" placeholder="信箱" value={this.state.email_F} onChange={this.handleChange} />
          </Col>
        </FormGroup>
        <GoogleReCaptcha
          onVerify={this.handleReCaptcha}
          refreshReCaptcha={this.state.refreshReCaptcha}
        />
        <FormGroup row>
          <Col sm={{ size: 10, offset: 2 }}>
            <Button color="primary" type="submit">送出</Button>
          </Col>
        </FormGroup>
      </Form>
    );
  }
}